(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funkaway-header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fa-menu-toggle]').forEach(function (btn) {
      var wrap = btn.closest('.fa-hdr-wrap');
      if (!wrap) return;
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-menu-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funkaway-product-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fa-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-fa-tab]');
      var panels = root.querySelectorAll('[data-fa-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-fa-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-fa-panel') === id);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funkaway-product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fa-accordion]').forEach(function (acc) {
      var items = acc.querySelectorAll('.fa-faq-pdp__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.fa-faq-pdp__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.fa-faq-pdp__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funkaway-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fa-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-fa-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-fa-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-fa-gallery-thumb');
          if (src) main.setAttribute('src', src);
          thumbs.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funkaway-support-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fa-accordion]').forEach(function (acc) {
      if (acc.dataset.faBound) return;
      acc.dataset.faBound = '1';
      var items = acc.querySelectorAll('.fa-supp-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.fa-supp-faq__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.fa-supp-faq__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funkaway-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fa-video-track]').forEach(function (track) {
      var section = track.closest('section');
      if (!section) return;
      var prev = section.querySelector('[data-fa-video-prev]');
      var next = section.querySelector('[data-fa-video-next]');
      function step(dir) {
        var card = track.querySelector('[data-fa-video-card]');
        var w = (card ? card.offsetWidth : 280) + 20;
        track.scrollBy({ left: w * dir, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      // Load lightweight poster thumbnails (via Vimeo oEmbed) only when the carousel nears the viewport.
      var facades = track.querySelectorAll('[data-fa-video-facade]');
      function loadPosters() {
        facades.forEach(function (btn) {
          var id = btn.getAttribute('data-video-id');
          var img = btn.querySelector('[data-fa-video-poster]');
          if (!id || !img || img.src) return;
          fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + id) + '&width=480')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (data && data.thumbnail_url) {
                img.src = data.thumbnail_url.replace(/_[0-9]+x[0-9]+/, '_720');
                img.hidden = false;
              }
            })
            .catch(function () {});
        });
      }
      loadPosters();

      // Click-to-play: the Vimeo player only boots for the tapped card.
      facades.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-video-id');
          var card = btn.closest('[data-fa-video-card]');
          if (!id || !card) return;
          var iframe = document.createElement('iframe');
          iframe.src = 'https://player.vimeo.com/video/' + id + '?byline=0&portrait=0&title=0&dnt=1&playsinline=1&autoplay=1';
          iframe.title = 'FunkAway video ' + id;
          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          card.replaceChild(iframe, btn);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
